import Day from "../Day"

export default function Week(props) {

    return (
        <div className="flex-container flex-width">
            {props.days.map((day, index) => {
                return <Day {...day} onChange={props.onChange} controllers={props.controllers} key={index + "_" + day.newDate.dayInt} />
            })
            }
        </div>
    )
} 